var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"app-footer"},[_c('b-nav',{attrs:{"align":"left"}},[_c('b-nav-item',{attrs:{"href":"https://rabbiitfirm.com/"}},[_vm._v("Rabbi IT Firm")]),_c('b-nav-item',{attrs:{"to":"/privacy-policy"}},[_vm._v(" Privacy Policy ")]),_c('b-nav-item',{attrs:{"to":"/about-us"}},[_vm._v(" About Us ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }